/*
 * myClass
 */
var MACRepublic = function () {

  /*
     * Variables accessible
     * in the class
     */
  var vars = {
    app_draft_api: 'https://app.shopifyexpertz.com/elephant-playing-cards/elephant-checkout-builder.php',
    app_root: 'https://app.shopifyexpertz.com/elephant-playing-cards/',
    filesadded: ''
  };

  //intit cart
  this.checkCart = function () {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        window.WR.common.Shopify.cart = JSON.parse(this.responseText);
      }
    };
    xhttp.open("GET", "cart.js");
    xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.send();
  };

  /*
     * Can access this.method
     * inside other methods using
     * root.method()
     */
  var root = this;

  var getCartToken = function () {
    return getCookie("cart");
  };

  var getCookie = function (t) {
    var e = "; " + document.cookie,
        n = e.split("; " + t + "=");
    if (2 === n.length)
      return n.pop().split(";").shift()
      }

  var getId = function () {
    return window.WR.common.Shopify.customer.id;
  };

  var b64EncodeUnicode = function (str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
                                                function toSolidBytes(match, p1) {
      return String.fromCharCode('0x' + p1);
    }));
  };

  var b64DecodeUnicode = function (str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  };

  /*
     * Public method
     * Can be called outside class
     */
  this.getShopKey = function () {
    return vars.sr_token;
  };
  this.isMACRInstalled = function () {
    return window.WR.MACORepublic.is_installed;
  };
  this.hasTags = function () {
    var t = this.getTags();
    return t && t.length > 0;
  };

  this.isLoggedIn = function () {
    return null !== getId();
  };

  this.getTemplate = function () {
    return window.WR.common.template;
  };
  this.getCheckoutButtons = function () {
    return document.querySelectorAll("[class=custom-checkout-btn],[name='checkout']");
  };

  this.getTags = function () {
    return window.WR.common.Shopify.customer.tags;
  };

  this.getCart = function () {
    return window.WR.common.Shopify.cart;
  };

  this.getCustomer = function () {
    return  window.WR.common.Shopify.customer;
  };

  this.getProxy = function () {
    return vars.sr_proxy;
  };

  this.getShopUrl = function () {
    return window.WR.common.Shopify.shop.secure_url
  };

  this.getShopDomain = function () {
    return window.WR.common.Shopify.shop.permanent_domain
  };

  this.getDraftOrderBuilderPath = function () {
    return vars.app_draft_api;
  };
  this.getRootPath = function () {
    return vars.app_root;
  };

  this.getVariants = function () {
    return window.WR.common.Shopify.variants || '';
  }

  this.removeFormElement = function (t, eleName) {
    if (t.length > 0) {
      for (i = 0; i < t.length; i++) {
        if (t.elements[i].name.toLowerCase() == eleName.toLowerCase()) {
          t.remove();
          return;
        }
      }
    }
  };
  createElement = function (t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
      n = document.createElement(t);
    if (null === e)
      return n;
    for (var r in e) {
      var o = e[r];
      switch (r) {
        case "innerHTML":
          n.innerHTML = o;
          break;
        case "text":
          n.appendChild(document.createTextNode(o));
          break;
        case "click":
        case "onClick":
          n.addEventListener("click", o);
          break;
        case "appendChild":
          n.appendChild(o);
          break;
        case "appendChildren":
          for (var i = 0; i < o.length; i++)
            n.appendChild(o[i]);
          break;
        default:
          n[r] = o
      }
    }
    return n
  };


  this.formatMoney = function (money) {
    var format = window.WR.common.Shopify.shop.money_format;
    return window.WR.common.Shopify.formatMoney(money, format);
  }


  this.setMACOOptions = function (t) {
    this.removeFormElement(t, 'shop');
    this.removeFormElement(t, 'cart_id');
    this.removeFormElement(t, 'shopify_customer_id');
    this.removeFormElement(t, 'cart');
    t.action = this.getDraftOrderBuilderPath(), t.appendChild(createElement("input", {
      type: "hidden",
      name: "cart_id",
      value: getCartToken()
    })), t.appendChild(createElement("input", {
      type: "hidden",
      name: "shopify_customer_id",
      value: getId()
    })), t.appendChild(createElement("input", {
      type: "hidden",
      name: "shop",
      value: this.getShopDomain()
    })), t.appendChild(createElement("input", {
      type: "hidden",
      name: "cart",
      value: b64EncodeUnicode(JSON.stringify(this.getCart()))
    }))
  };
};

var MACRepublicObj = new MACRepublic();
var strTemplate = MACRepublicObj.getTemplate();

if (MACRepublicObj.isMACRInstalled()) {
  function initLoad() {
    var checkoutBtns = MACRepublicObj.getCheckoutButtons();
    if (checkoutBtns.length > 0) {
      checkoutBtns.forEach(function (btn) {
        $('body').on('click','.custom-checkout-btn',function(e) {
          e.preventDefault();
          e.stopPropagation();
          btn.click();
        });
        if (btn.name.toLowerCase() == 'checkout') {
          btn.addEventListener("click", function (e) {
            e.preventDefault();
            if (btn.form.checkValidity()) {
              /**/
              var data = $(this).parents('form').serialize();
              $.ajax({
                url: '/cart/update.js',
                type: 'POST',
                dataType: 'json',
                data: data,
                success: function(result) {
                  var cartdata1 = [];
                  $.ajax({ 
                    type: 'GET',
                    url: '/cart.js',
                    async: false, 
                    cache: false, 
                    dataType: 'json',
                    success: function (json) {
                      cartdata1 = json;
                    }
                  });
                  MACRepublicObj.checkCart();
                  MACRepublicObj.getCart();
                  MACRepublicObj.setMACOOptions(btn.form);
                  btn.form.submit();
                },
                error: function(jqxhr, status) {
                  console.log(jqxhr);
                  console.log(status);
                }
              });
            }
          });
        }
      });
    }
  }

  window.addEventListener('load', function () {
    initLoad();
  });
}